import { Produit } from './produit';
import { Facture } from './facture';

export class Commande {

    id: number;
    quantite: number;
    prix_unitaire: number;
    produit: Produit;
    remise: number;
    facture: Facture;
    tva: number;
    type_calcul_tva: string;
    description: string;

    constructor() {
        // super(); // on appelle le constructeur du parent;
        this.id = 0;
        this.quantite = 0;
        this.prix_unitaire = 0;
        this.type_calcul_tva = 'pourcentage';
    }

    get prixTotal(): number {
        return this.prixHT + this.montantTVA;
    }

    get prixHT(): number {
        if (this.quantite === null || this.prix_unitaire === null )
        return 0;
        else {
            if (this.remise === null || this.remise === undefined )
            return this.quantite * this.prix_unitaire;
            else
            return this.quantite * this.prix_unitaire - this.remise;
        }
    }


    get montantTVA(): number {
        if ( (this.produit !== undefined && this.produit.is_emballage) || this.tva === null || this.tva === undefined)
        return 0;
        else {

            if (this.type_calcul_tva === 'pourcentage')
            return (this.prixHT * this.tva) / 100;
            else
            return this.quantite * this.tva;
        }
    }

    

    get nomProduit(): string {
        if ( this.description === undefined || this.description === null) {

            if (this.produit !== undefined)
            return this.produit.designation;
            else
            return '';
        } else {
            return this.description;
        }

    }

    get prixUnitaireRetour(): number {

        if ( this.quantite === 0 )
        return 0;

        if( this.produit !== undefined && !this.produit.is_emballage){

            let montantTaxe = 0;

            if( this.facture !== undefined && this.facture.taxes !== undefined && this.facture.taxes !== null) {

                this.facture.taxes.forEach( elem => {
                    // pour tenir compte de la remise on prend le prix hors taxe
                    montantTaxe += this.facture.montantTaxe(elem, this.prixHT/this.quantite, this.prixTotal/this.quantite, 1)
                });

            }

            return Math.round((this.prixHT + this.montantTVA) / this.quantite + montantTaxe);

        }
        else {

            if(this.produit !== undefined && this.produit.is_emballage )
            return this.prix_unitaire;
        }

    }


}
